import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { indigo, blueGrey } from "@material-ui/core/colors";

const theme = createMuiTheme({
	palette: {
		primary: indigo,
		secondary: blueGrey,
	},
});

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

ReactDOM.render(
	<BrowserRouter basename={baseUrl}>
		<MuiThemeProvider theme={theme}>
			<App />
		</MuiThemeProvider>
	</BrowserRouter>,
	rootElement
);

// registerServiceWorker();
